<template>
  <div class="tariffs-services">
    <h2 id="additionalServices">{{ data.title }}</h2>
    <div class="mt-30" v-html="data.description" />
    <div class="tariffs-services-items mt-10">
      <div v-for="item in items" class="tariffs-services-item flex flex-align-items-start mt-20">
        <vz-icon
          :name="item.icon.name"
          :url="item.icon.url"
          :size="item.icon.size"
          :no-masked-icon="isNoMaskedIcon(item)"
          variant="primary"
          class="mr-10"
        />
        <div class="tariffs-services-item-wrapper">
          <div class="text-bold mb-5">{{ item.title }}</div>
          <span v-html="item.text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PublicInfoGridItem } from "~~/types/public";
import {getPageContent} from '~/api/content';

const content = await getPageContent('/tariffs')

const data = computed(() => {
  return content.blocks?.additionalServices || {}
})

const items = computed(() => {
  return [
    {
      icon: {
        url: '/svg/load-box.svg',
        size: 20
      },
      title: data.value.pprTitle,
      text: data.value.pprText,
    },
    {
      icon: {
        url: '/svg/package.svg',
        size: 19
      },
      title: data.value.wrappingTitle,
      text: data.value.wrappingText,
    },
    {
      icon: {
        name: 'map-marker',
        size: 24,
      },
      title: data.value.addressDeliveryTitle,
      text: data.value.addressDeliveryText,
    },
    {
      icon: {
        name: 'shield',
        size: 20
      },
      title: data.value.insuranceTitle,
      text: data.value.insuranceText,
    }
  ]
})

function isNoMaskedIcon(item: PublicInfoGridItem): boolean {
  return Boolean(item.icon?.url)
}
</script>
